// src/components/layout/AboutSection.jsx
import React, { useEffect, useRef, useState } from 'react';
import '../../styles/about.css';

const AboutSection = ({ college }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  // 1. Define standard placeholders (used only if your new array is missing)
  const placeholders = [
    "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1000&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1562774053-701939374585?q=80&w=1000&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1592280771190-3e2e4d50c2bc?q=80&w=1000&auto=format&fit=crop"
  ];

  // 2. Define 'aboutImages' logic
  // PRIORITY: Check college.aboutImages (The new array you will create)
  // FALLBACK: Use main college image + placeholders
  // EXCLUDED: We do NOT use college.galleryImages here to avoid duplicates.
  
  const aboutImages = (college.aboutImages && college.aboutImages.length > 0) 
    ? college.aboutImages 
    : [
        college.image || placeholders[0], // Slot 1: Main Image
        placeholders[1],                  // Slot 2: Placeholder
        placeholders[2]                   // Slot 3: Placeholder
      ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section 
      ref={sectionRef} 
      className={`about-section ${isVisible ? 'is-visible' : ''}`}
    >
      <div className="about-container">
        
        {/* --- Top: Header & Text --- */}
        <div className="about-content">
          <div className="about-header">
            <h2 className="about-title">About {college.name}</h2>
          </div>
          
          <div className="about-text">
            <p>{college.overview}</p>
          </div>
        </div>

        {/* --- Bottom: 3 Rectangular Images --- */}
        <div className="about-gallery">
          {/* We now map over 'aboutImages' specifically */}
          {aboutImages.slice(0, 3).map((imgSrc, index) => (
            <div key={index} className="gallery-item" style={{ transitionDelay: `${index * 0.15 + 0.5}s` }}>
              <img 
                src={imgSrc} 
                alt={`${college.name} view ${index + 1}`}
                onError={(e) => { e.target.src = placeholders[index % 3]; }} 
              />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AboutSection;